(function () {
  var amazon_loaded = false;

  function loadAmazonTag() {
    if (amazon_loaded) return;
    amazon_loaded = true;

    !function(w,d,s,t,a){if(w.amzn)return;w.amzn=a=function(){w.amzn.q.push([arguments,(new Date).getTime()])};a.q=[];a.version="0.0";s=d.createElement("script");s.src="https://c.amazon-adsystem.com/aat/amzn.js";s.id="amzn-pixel";s.async=true;t=d.getElementsByTagName("script")[0];t.parentNode.insertBefore(s,t)}(window,document);

    amzn("setRegion", "NA");
    amzn("addTag", "4403726d-eb8d-4f7e-892a-2ddb1694098a");
    amzn("trackEvent", "PageView");
  }

  function marketingAllowed() {
    var privacy_api = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy_api) return false;
    return privacy_api.analyticsProcessingAllowed() && privacy_api.marketingAllowed();
  }

  document.addEventListener('visitorConsentCollected', function (event) {
    if (event.detail.marketingAllowed) loadAmazonTag();
  });

  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error) return;
        if (marketingAllowed()) loadAmazonTag();
      }
    );
  }
})();